import { useEffect } from "react";

/**
 * Adds a CSS class to document.body on mount, removes it on unmount.
 * @param {string} className - defaults to "bg-alice"
 */
const usePageBackground = (className = "bg-alice") => {
  useEffect(() => {
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);
};

export default usePageBackground;
